// extracted by mini-css-extract-plugin
export default {"wrapper":"D1wAPlB_","neonWrapper":"JEct39OZ","button":"r9XbOU9W"};